import { Injectable } from '@angular/core';
import { DriveServiceProvider } from '../drive-service/drive-service';
import { ConfigApiServiceProvider } from '../config-api-service/config-api-service';
import { StoreWrapProvider } from '../store-wrap/store-wrap';
import { ToastController } from 'ionic-angular';

@Injectable()
export class ContactManagerProvider {
  arrCurrentChildFolder: any = [];
  arrContactFolder: any = [];
  emailList: any = [];
  constructor(public driveService: DriveServiceProvider, public toastCtrl: ToastController, public configApi: ConfigApiServiceProvider, public storeWrap: StoreWrapProvider) {
    console.log('Hello ContactManagerProvider Provider');
  }

  getContactFolders() {
    this.arrContactFolder = [];
    // let folder = this.driveService.objRootFolder.folders;
    let contactFolder = this.driveService.objRootFolder.folders.find(foldersList => foldersList['folder_id'] == this.configApi.driveApi.defaultContactFolder.params.folder_id);
    if (contactFolder != undefined) {
      this.arrContactFolder.push(contactFolder);
      for (var i = 0; i < contactFolder['folders'].length; i++) {
        this.arrContactFolder.push(contactFolder['folders'][i])
      }


      // for (let i = 0; i < folder.length; i++) {
      //   if (folder[i].name == "Contacts") {
      //     for (let j = 0; j < folder[i].folders.length; j++) {
      //       this.arrCurrentChildFolder.push(folder[i].folders[j])
      //     }
      //   }
      // }

      // if(this.driveService.objCurrentParentFolder.template.findIndex(element=>element.id==this.configApi.driveApi.defaultContactFolder.params.templateId) != -1){
      // this.arrCurrentChildFolder = this.driveService.objCurrentParentFolder.folders;
      // }
      return this.arrContactFolder;
    }
  }

  getCurrentFolderTemplate(currentFolder) {
    this.arrCurrentChildFolder = [];
    let folder = currentFolder.folders;
    if (this.storeWrap.storeTemplates[currentFolder.template[0].id]) {
      if (this.storeWrap.storeTemplates[currentFolder.template[0].id].category != "Blank") {
        this.arrCurrentChildFolder.push(this.storeWrap.storeTemplates[currentFolder.template[0].id]);
      }
    }
    folder.forEach(element => {
      let folderTemplate = element.template;
      if (folderTemplate.length > 1) {
        folderTemplate.forEach(element => {
          if (element) {
            if (this.arrCurrentChildFolder.findIndex(temp => temp.id == element.id) == -1) {
              if (this.storeWrap.storeTemplates[element.id]) {
                if (this.storeWrap.storeTemplates[element.id].category != "Blank") {
                  this.arrCurrentChildFolder.push(this.storeWrap.storeTemplates[element.id]);
                }
              }
            }
          }
        });
      } else {
        if (folderTemplate.length > 0) {
          if (this.arrCurrentChildFolder.length > 0) {
            if (this.arrCurrentChildFolder.findIndex(temp => temp.id == folderTemplate[0].id) == -1) {
              if (this.storeWrap.storeTemplates[folderTemplate[0].id]) {
                if (this.storeWrap.storeTemplates[folderTemplate[0].id].category != "Blank") {
                  this.arrCurrentChildFolder.push(this.storeWrap.storeTemplates[folderTemplate[0].id]);
                }
              }
            }
          } else {
            if (this.storeWrap.storeTemplates[folderTemplate[0].id]) {
              if (this.storeWrap.storeTemplates[folderTemplate[0].id].category != "Blank")
                this.arrCurrentChildFolder.push(this.storeWrap.storeTemplates[folderTemplate[0].id]);
            }
          }
        }
      }
    });

    // let contactFolder =this.driveService.objRootFolder.folders.find(foldersList=>foldersList['folder_id']==this.configApi.driveApi.defaultContactFolder.params.folder_id);
    // this.arrContactFolder.push(contactFolder);
    // for(var i=0;i<contactFolder['folders'].length;i++){
    //   this.arrContactFolder.push(contactFolder['folders'][i])
    // }
    return this.arrCurrentChildFolder;
  }

  getSelectedFolders(folder, type) {
    let arrCurrentChildSelectedFolder = [];
    if (folder) {
      var folder = JSON.parse(folder);
      // let folder_id;
      // let arrCurrentChildSelectedFolder=[];
      // this.driveService.objRootFolder
      let contactFolder = this.driveService.objRootFolder.folders.find(foldersList => foldersList['folder_id'] == this.configApi.driveApi.defaultContactFolder.params.folder_id);
      if (folder[type]) {
        let folder_id = folder[type].split(',');
        folder_id.forEach(element => {
          if (contactFolder.folders.find(folder => folder.folder_id == element)) {

            arrCurrentChildSelectedFolder.push(Object.assign({}, contactFolder.folders.find(folder => folder.folder_id == element), { 'display': contactFolder.folders.find(folder => folder.folder_id == element).name, 'value': contactFolder.folders.find(folder => folder.folder_id == element).folder_id }));
          } else {
            arrCurrentChildSelectedFolder.push(Object.assign({}, this.driveService.objRootFolder.folders.find(foldersList => foldersList['folder_id'] == element), { 'display': this.driveService.objRootFolder.folders.find(foldersList => foldersList['folder_id'] == element).name, 'value': this.driveService.objRootFolder.folders.find(foldersList => foldersList['folder_id'] == element).folder_id }));
          }

        });
      }


    }

    return arrCurrentChildSelectedFolder;
  }

  addContact() {

  }

  private constructParams(params): any {
    if (Object.keys(params).length) {
      return JSON.stringify(params);
    }
    return '';
  }
  getMailList(folder, cbck) {
    let ftemp = folder.template;
    let getTemplateProp: any;
    let emailList: any = [];
    if (ftemp.length > 1) {

    } else {
      getTemplateProp = this.storeWrap.storeTemplates[ftemp[0]['id']].pullParams;
      let templateIdx = folder.template.findIndex(function (element, i) { return element.id === ftemp[0]['id'] });

      let filterParams = (templateIdx === -1 ? {} : folder['template'][templateIdx]['filterParams']);
      let templateParam = (JSON.parse(JSON.stringify(getTemplateProp)));
      let filterData = this.constructParams(filterParams);
      if (filterData !== '') {
        templateParam['filterData'] = filterData;
      }
      this.configApi.pullRequest(templateParam, (responseData) => {
        console.log('email Response Data', responseData);
        responseData.forEach(element => {
          let defaultContactFolderSrcyKey = this.configApi.driveApi.defaultContactFolder.params.sourceKey.toLowerCase();
          Object.keys(element).map(key => {
            if (key.toLowerCase() != key) {
              element[key.toLowerCase()] = element[key];
              delete element[key];
            }
          });
          if (element.hasOwnProperty(defaultContactFolderSrcyKey)) {
            return emailList.push(element[defaultContactFolderSrcyKey]);
          }
        })
        if (emailList.length > 0) {
          if (this.emailList.length > 0) {
            this.emailList = this.emailList.concat(emailList);
          } else {
            this.emailList = emailList;
          }
          console.log(this.emailList);
          cbck(emailList);
        } else {
          const toast = this.toastCtrl.create({
            message: 'Email Ids are not presented',
            duration: 2000
          });
          toast.present();
        }
      })

    }
  }



  getFormMailList() {
    let mailList: any = [];
    mailList = [this.driveService.objUserLoginDetails.email_id, 'support@eprodcast.com']
    return mailList;
  }

}



// WEBPACK FOOTER //
// ./src/providers/contact-manager/contact-manager.ts